// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduledVisitItem-module__font-s-10___Uae_F {
  font-size: 10px !important;
}

.ScheduledVisitItem-module__font-s-12___aMWSk {
  font-size: 12px !important;
}

.ScheduledVisitItem-module__font-s-13___PLioo {
  font-size: 13px !important;
}

.ScheduledVisitItem-module__font-s-14___NtcpH {
  font-size: 14px !important;
}

.ScheduledVisitItem-module__font-s-15___OCE6A {
  font-size: 15px !important;
}

.ScheduledVisitItem-module__font-s-16___wcxwi {
  font-size: 16px !important;
}

.ScheduledVisitItem-module__font-s-18___Z9LhE {
  font-size: 18px !important;
}

.ScheduledVisitItem-module__font-s-20___QgFWp {
  font-size: 20px !important;
}

.ScheduledVisitItem-module__font-s-22___JLf4_ {
  font-size: 22px !important;
}

.ScheduledVisitItem-module__font-s-28____Xe3w {
  font-size: 28px !important;
}

.ScheduledVisitItem-module__font-w-400___LL2au {
  font-weight: 400 !important;
}

.ScheduledVisitItem-module__font-w-500___zX905 {
  font-weight: 500 !important;
}

.ScheduledVisitItem-module__font-w-600___SBRim {
  font-weight: 600 !important;
}

.ScheduledVisitItem-module__font-w-700___rv2Rs {
  font-weight: 700 !important;
}

.ScheduledVisitItem-module__p-5___FZLUV {
  padding: 5px !important;
}

.ScheduledVisitItem-module__p-12___Xvkpc {
  padding: 12px !important;
}

.ScheduledVisitItem-module__p-16___R4p9s {
  padding: 16px !important;
}

.ScheduledVisitItem-module__p-30___HFzXB {
  padding: 30px !important;
}

.ScheduledVisitItem-module__p-b-0___Gj9Z6 {
  padding-bottom: 0 !important;
}

.ScheduledVisitItem-module__p-b-5___YAjtX {
  padding-bottom: 5px !important;
}

.ScheduledVisitItem-module__p-b-10___fT2N8 {
  padding-bottom: 10px !important;
}

.ScheduledVisitItem-module__p-b-12___JAklB {
  padding-bottom: 12px !important;
}

.ScheduledVisitItem-module__p-b-16___Lr45N {
  padding-bottom: 16px !important;
}

.ScheduledVisitItem-module__p-b-18___TggvD {
  padding-bottom: 18px !important;
}

.ScheduledVisitItem-module__p-b-20___tMjSw {
  padding-bottom: 20px !important;
}

.ScheduledVisitItem-module__p-b-25___AZQjt {
  padding-bottom: 25px !important;
}

.ScheduledVisitItem-module__p-b-30___p_kzF {
  padding-bottom: 30px !important;
}

.ScheduledVisitItem-module__p-b-50___LDSYV {
  padding-bottom: 50px !important;
}

.ScheduledVisitItem-module__p-t-0___fkAIH {
  padding-top: 0 !important;
}

.ScheduledVisitItem-module__p-t-12___lVBW9 {
  padding-top: 12px !important;
}

.ScheduledVisitItem-module__p-t-16___Okf8i {
  padding-top: 16px !important;
}

.ScheduledVisitItem-module__p-t-18___xSoyE {
  padding-top: 18px !important;
}

.ScheduledVisitItem-module__p-t-20___Puj4b {
  padding-top: 20px !important;
}

.ScheduledVisitItem-module__p-t-30___LrP0f {
  padding-top: 30px !important;
}

.ScheduledVisitItem-module__p-t-40___Da8nJ {
  padding-top: 40px !important;
}

.ScheduledVisitItem-module__p-t-50___lfccx {
  padding-top: 50px !important;
}

.ScheduledVisitItem-module__p-l-20___jfSZH {
  padding-left: 20px !important;
}

.ScheduledVisitItem-module__p-l-30___FQifZ {
  padding-left: 30px !important;
}

.ScheduledVisitItem-module__p-l-40___TgMc4 {
  padding-left: 40px !important;
}

.ScheduledVisitItem-module__p-r-16___bmcgf {
  padding-right: 16px !important;
}

.ScheduledVisitItem-module__p-r-20___tTdyB {
  padding-right: 20px !important;
}

.ScheduledVisitItem-module__p-r-30___pX8Uu {
  padding-right: 30px !important;
}

.ScheduledVisitItem-module__p-r-50___AeHwU {
  padding-right: 50px !important;
}

.ScheduledVisitItem-module__p-r-60___o11h6 {
  padding-right: 60px !important;
}

.ScheduledVisitItem-module__m-b-1___AR_WI {
  margin-bottom: 1px !important;
}

.ScheduledVisitItem-module__m-b-2___YLszg {
  margin-bottom: 2px !important;
}

.ScheduledVisitItem-module__m-b-6___tCUj5 {
  margin-bottom: 6px !important;
}

.ScheduledVisitItem-module__m-b-8___k_NqQ {
  margin-bottom: 8px !important;
}

.ScheduledVisitItem-module__m-b-10___EkM1x {
  margin-bottom: 10px !important;
}

.ScheduledVisitItem-module__m-b-14___Ku3ow {
  margin-bottom: 14px !important;
}

.ScheduledVisitItem-module__m-b-16___TKFaF {
  margin-bottom: 16px !important;
}

.ScheduledVisitItem-module__m-b-20___NgiII {
  margin-bottom: 20px !important;
}

.ScheduledVisitItem-module__m-b-22___k9djL {
  margin-bottom: 22px !important;
}

.ScheduledVisitItem-module__m-b-24___n5Gkf {
  margin-bottom: 24px !important;
}

.ScheduledVisitItem-module__m-b-30___hBL_D {
  margin-bottom: 30px !important;
}

.ScheduledVisitItem-module__m-b-32____EZkS {
  margin-bottom: 32px !important;
}

.ScheduledVisitItem-module__m-b-40___FWulo {
  margin-bottom: 40px !important;
}

.ScheduledVisitItem-module__m-t-2___H4Drw {
  margin-top: 2px !important;
}

.ScheduledVisitItem-module__m-t-3___C5NKg {
  margin-top: 3px !important;
}

.ScheduledVisitItem-module__m-t-4___q6rt6 {
  margin-top: 4px !important;
}

.ScheduledVisitItem-module__m-t-5___ES96z {
  margin-top: 5px !important;
}

.ScheduledVisitItem-module__m-t-8___DdAdB {
  margin-top: 8px !important;
}

.ScheduledVisitItem-module__m-t-10___vQ85N {
  margin-top: 10px !important;
}

.ScheduledVisitItem-module__m-t-15___KQlET {
  margin-top: 15px !important;
}

.ScheduledVisitItem-module__m-t-16___BVwZY {
  margin-top: 16px !important;
}

.ScheduledVisitItem-module__m-t-20___ro3TJ {
  margin-top: 20px !important;
}

.ScheduledVisitItem-module__m-t-22___rgLNt {
  margin-top: 22px !important;
}

.ScheduledVisitItem-module__m-t-30___bMXct {
  margin-top: 30px !important;
}

.ScheduledVisitItem-module__m-t-32___sR1E7 {
  margin-top: 32px !important;
}

.ScheduledVisitItem-module__m-l-auto___DaaOT {
  margin-left: auto !important;
}

.ScheduledVisitItem-module__m-l-4___Ka1MC {
  margin-left: 4px !important;
}

.ScheduledVisitItem-module__m-l-5____XA_w {
  margin-left: 5px !important;
}

.ScheduledVisitItem-module__m-l-6___MIG5x {
  margin-left: 6px !important;
}

.ScheduledVisitItem-module__m-l-8___Yq1Cn {
  margin-left: 8px !important;
}

.ScheduledVisitItem-module__m-l-10___QwMWW {
  margin-left: 10px !important;
}

.ScheduledVisitItem-module__m-l-16___BGByq {
  margin-left: 16px !important;
}

.ScheduledVisitItem-module__m-l-20___nXcJ2 {
  margin-left: 20px !important;
}

.ScheduledVisitItem-module__m-l-24___A2QCw {
  margin-left: 24px !important;
}

.ScheduledVisitItem-module__m-l-30___nvV0R {
  margin-left: 30px !important;
}

.ScheduledVisitItem-module__m-l-35___ueZ8H {
  margin-left: 35px !important;
}

.ScheduledVisitItem-module__m-l-40___j4DQz {
  margin-left: 40px !important;
}

.ScheduledVisitItem-module__m-r-8___tFKeD {
  margin-right: 8px !important;
}

.ScheduledVisitItem-module__m-r-10___kgxqs {
  margin-right: 10px !important;
}

.ScheduledVisitItem-module__m-r-16___RiOdE {
  margin-right: 16px !important;
}

.ScheduledVisitItem-module__m-r-20___LyA1l {
  margin-right: 20px !important;
}

.ScheduledVisitItem-module__m-r-24___HLdF7 {
  margin-right: 24px !important;
}

.ScheduledVisitItem-module__m-r-30___JSKIr {
  margin-right: 30px !important;
}

.ScheduledVisitItem-module__m-r-40___GZdA6 {
  margin-right: 40px !important;
}

.ScheduledVisitItem-module__border-r-3___NXACp {
  border-radius: 3px !important;
}

.ScheduledVisitItem-module__border-r-4___kRmxm {
  border-radius: 4px !important;
}

.ScheduledVisitItem-module__border-r-6___E_7wk {
  border-radius: 6px !important;
}

.ScheduledVisitItem-module__border-r-10___VZDIq {
  border-radius: 10px !important;
}

.ScheduledVisitItem-module__border-r-12___VJ7A4 {
  border-radius: 12px !important;
}

.ScheduledVisitItem-module__border-r-16___nHdQw {
  border-radius: 16px !important;
}

.ScheduledVisitItem-module__border-r-50___KwZ7V {
  border-radius: 50% !important;
}

.ScheduledVisitItem-module__primary-border___eYcEK {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledVisitItem-module__primary-border-b___LsVTV {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledVisitItem-module__primary-border-t___vzyJP {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledVisitItem-module__primary-border-l___Kl4sL {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledVisitItem-module__primary-border-r___oQ5at {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledVisitItem-module__secondary-border___xVcLN {
  border: 1px solid #637768;
}

.ScheduledVisitItem-module__secondary-border-b___gaJLD {
  border-bottom: 1px solid #637768;
}

.ScheduledVisitItem-module__secondary-border-t___Y6TOI {
  border-top: 1px solid #637768;
}

.ScheduledVisitItem-module__secondary-border-l___RW1ov {
  border-left: 1px solid #637768;
}

.ScheduledVisitItem-module__secondary-border-r___Su0oG {
  border-right: 1px solid #637768;
}

.ScheduledVisitItem-module__gap-0___c7IWU {
  gap: 0 !important;
}

.ScheduledVisitItem-module__gap-2___D1T6A {
  gap: 2px !important;
}

.ScheduledVisitItem-module__gap-4___cXZYT {
  gap: 4px !important;
}

.ScheduledVisitItem-module__gap-5___Wo6KK {
  gap: 5px !important;
}

.ScheduledVisitItem-module__gap-6___rW4Uv {
  gap: 6px !important;
}

.ScheduledVisitItem-module__gap-8___P2JB2 {
  gap: 8px !important;
}

.ScheduledVisitItem-module__gap-10___MjKhe {
  gap: 10px !important;
}

.ScheduledVisitItem-module__gap-12___GjGvd {
  gap: 12px !important;
}

.ScheduledVisitItem-module__gap-14___sqFwC {
  gap: 14px !important;
}

.ScheduledVisitItem-module__gap-16___X1zh1 {
  gap: 16px !important;
}

.ScheduledVisitItem-module__gap-18___q9P9a {
  gap: 18px !important;
}

.ScheduledVisitItem-module__gap-20___eFx95 {
  gap: 20px !important;
}

.ScheduledVisitItem-module__gap-24___HNaQv {
  gap: 24px !important;
}

.ScheduledVisitItem-module__gap-26___m_1V5 {
  gap: 26px !important;
}

.ScheduledVisitItem-module__gap-30___YG_Tq {
  gap: 30px !important;
}

.ScheduledVisitItem-module__gap-32___RUBGV {
  gap: 32px !important;
}

.ScheduledVisitItem-module__gap-40___Cx74p {
  gap: 40px !important;
}

.ScheduledVisitItem-module__gap-50___EBqTL {
  gap: 50px !important;
}

.ScheduledVisitItem-module__flex-1___rE3Wk {
  flex: 1;
}

.ScheduledVisitItem-module__flex-none___ri2gv {
  flex: none !important;
}

.ScheduledVisitItem-module__flex-column___IviW_ {
  display: flex;
  flex-direction: column !important;
}

.ScheduledVisitItem-module__flex-row___ipytB {
  display: flex;
  flex-direction: row !important;
}

.ScheduledVisitItem-module__vertically-centered___iD22A {
  display: flex;
  align-items: center !important;
}

.ScheduledVisitItem-module__horizontally-centered___xIsjX {
  display: flex;
  justify-content: center !important;
}

.ScheduledVisitItem-module__horizontally-end___tduRK {
  display: flex;
  justify-content: end !important;
}

.ScheduledVisitItem-module__vertically-start___QOt5p {
  display: flex;
  align-items: start !important;
}

.ScheduledVisitItem-module__space-between___BGwJt {
  display: flex;
  justify-content: space-between !important;
}

.ScheduledVisitItem-module__flex-wrap___ObCid {
  flex-wrap: wrap !important;
}

.ScheduledVisitItem-module__height-100___MbTtp {
  height: 100%;
}

.ScheduledVisitItem-module__width-50___QAb4a {
  width: 50% !important;
}

.ScheduledVisitItem-module__width-100___yuY3z {
  width: 100%;
}

.ScheduledVisitItem-module__cursor-pointer___Pl0DM {
  cursor: pointer;
}

.ScheduledVisitItem-module__cursor-not-allowed___h7bu8 {
  cursor: not-allowed !important;
}

.ScheduledVisitItem-module__absolute-centered___yWKxL {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ScheduledVisitItem-module__absolute___KZPRE {
  position: absolute;
}

.ScheduledVisitItem-module__relative___s4cOP {
  position: relative;
}

.ScheduledVisitItem-module__fixed___QjJQR {
  position: fixed;
}

.ScheduledVisitItem-module__visible___jLlUZ {
  opacity: 1;
}

.ScheduledVisitItem-module__invisible___SnwZ0 {
  opacity: 0;
}

.ScheduledVisitItem-module__col-90___Dam91 {
  width: 90% !important;
}

.ScheduledVisitItem-module__col-auto___FLkT4 {
  width: auto !important;
}

.ScheduledVisitItem-module__medical-tabs___VFtDd {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ScheduledVisitItem-module__medical-table-new___QsF7r {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ScheduledVisitItem-module__medical-table-new___QsF7r:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ScheduledVisitItem-module__medical-table-new___QsF7r::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ScheduledVisitItem-module__medical-table-new___QsF7r::-webkit-scrollbar-track {
  display: none;
}
.ScheduledVisitItem-module__medical-table-new___QsF7r.ScheduledVisitItem-module__no-pagination___qbMNv {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ScheduledVisitItem-module__medical-table-new___QsF7r.ScheduledVisitItem-module__no-pagination___qbMNv:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ScheduledVisitItem-module__medical-table-new___QsF7r.ScheduledVisitItem-module__no-pagination___qbMNv::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ScheduledVisitItem-module__medical-table-new___QsF7r.ScheduledVisitItem-module__no-pagination___qbMNv::-webkit-scrollbar-track {
  display: none;
}

.ScheduledVisitItem-module__medical-table-empty___X6I9f {
  padding: 14px 40px !important;
}

.ScheduledVisitItem-module__icon-btn___TGQNH {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ScheduledVisitItem-module__search-icon___IdNRs {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ScheduledVisitItem-module__disable-select___cqNIY {
  user-select: none;
}

.ScheduledVisitItem-module__break-word___aryMq {
  word-break: break-word;
}

.ScheduledVisitItem-module__popup-clear-btn___Qw4xt {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ScheduledVisitItem-module__scroll-m-b-20___Bf6gh {
  scroll-margin-bottom: 20px;
}

.ScheduledVisitItem-module__container___E_TcF {
  background-color: #fdfcfa;
  cursor: pointer;
}
.ScheduledVisitItem-module__container___E_TcF.ScheduledVisitItem-module__checked___L5DTl {
  background-color: #f1f3e7;
}
.ScheduledVisitItem-module__container___E_TcF.ScheduledVisitItem-module__disabled___jCWXQ {
  cursor: not-allowed;
  opacity: 0.7;
}
.ScheduledVisitItem-module__container___E_TcF .ScheduledVisitItem-module__icon___CYfep {
  width: 34px;
  height: 34px;
}
.ScheduledVisitItem-module__container___E_TcF .ScheduledVisitItem-module__title___bIOW6 {
  color: #a79988;
}
.ScheduledVisitItem-module__container___E_TcF .ScheduledVisitItem-module__type___O85l3 {
  color: #375844;
}
.ScheduledVisitItem-module__container___E_TcF .ScheduledVisitItem-module__time___dbOVd {
  color: #637768;
}
.ScheduledVisitItem-module__container___E_TcF .ScheduledVisitItem-module__checkbox___JY686 {
  background-color: transparent;
  align-self: center;
  min-width: 140px;
  height: 20px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/modules/LinkedVsitsModule/ScheduledVisits/ScheduledVisitItem/ScheduledVisitItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,yBAAA;EACA,eAAA;AA8pBF;AA5pBE;EACE,yBAAA;AA8pBJ;AA3pBE;EACE,mBAAA;EACA,YAAA;AA6pBJ;AA1pBE;EACE,WAAA;EACA,YAAA;AA4pBJ;AAzpBE;EACE,cAAA;AA2pBJ;AAxpBE;EACE,cAAA;AA0pBJ;AAvpBE;EACE,cAAA;AAypBJ;AAtpBE;EACE,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAwpBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  background-color: get-color(grayNew, ultra-light);\n  cursor: pointer;\n\n  &.checked {\n    background-color: get-color(greenNew, lighter);\n  }\n\n  &.disabled {\n    cursor: not-allowed;\n    opacity: 0.7;\n  }\n\n  .icon {\n    width: 34px;\n    height: 34px;\n  }\n\n  .title {\n    color: get-color(orangeNew, medium-dark);\n  }\n\n  .type {\n    color: get-color(greenNew, dark);\n  }\n\n  .time {\n    color: get-color(greenNew, medium-dark);\n  }\n\n  .checkbox {\n    background-color: transparent;\n    align-self: center;\n    min-width: 140px;\n    height: 20px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ScheduledVisitItem-module__font-s-10___Uae_F`,
	"fontS12": `ScheduledVisitItem-module__font-s-12___aMWSk`,
	"fontS13": `ScheduledVisitItem-module__font-s-13___PLioo`,
	"fontS14": `ScheduledVisitItem-module__font-s-14___NtcpH`,
	"fontS15": `ScheduledVisitItem-module__font-s-15___OCE6A`,
	"fontS16": `ScheduledVisitItem-module__font-s-16___wcxwi`,
	"fontS18": `ScheduledVisitItem-module__font-s-18___Z9LhE`,
	"fontS20": `ScheduledVisitItem-module__font-s-20___QgFWp`,
	"fontS22": `ScheduledVisitItem-module__font-s-22___JLf4_`,
	"fontS28": `ScheduledVisitItem-module__font-s-28____Xe3w`,
	"fontW400": `ScheduledVisitItem-module__font-w-400___LL2au`,
	"fontW500": `ScheduledVisitItem-module__font-w-500___zX905`,
	"fontW600": `ScheduledVisitItem-module__font-w-600___SBRim`,
	"fontW700": `ScheduledVisitItem-module__font-w-700___rv2Rs`,
	"p5": `ScheduledVisitItem-module__p-5___FZLUV`,
	"p12": `ScheduledVisitItem-module__p-12___Xvkpc`,
	"p16": `ScheduledVisitItem-module__p-16___R4p9s`,
	"p30": `ScheduledVisitItem-module__p-30___HFzXB`,
	"pB0": `ScheduledVisitItem-module__p-b-0___Gj9Z6`,
	"pB5": `ScheduledVisitItem-module__p-b-5___YAjtX`,
	"pB10": `ScheduledVisitItem-module__p-b-10___fT2N8`,
	"pB12": `ScheduledVisitItem-module__p-b-12___JAklB`,
	"pB16": `ScheduledVisitItem-module__p-b-16___Lr45N`,
	"pB18": `ScheduledVisitItem-module__p-b-18___TggvD`,
	"pB20": `ScheduledVisitItem-module__p-b-20___tMjSw`,
	"pB25": `ScheduledVisitItem-module__p-b-25___AZQjt`,
	"pB30": `ScheduledVisitItem-module__p-b-30___p_kzF`,
	"pB50": `ScheduledVisitItem-module__p-b-50___LDSYV`,
	"pT0": `ScheduledVisitItem-module__p-t-0___fkAIH`,
	"pT12": `ScheduledVisitItem-module__p-t-12___lVBW9`,
	"pT16": `ScheduledVisitItem-module__p-t-16___Okf8i`,
	"pT18": `ScheduledVisitItem-module__p-t-18___xSoyE`,
	"pT20": `ScheduledVisitItem-module__p-t-20___Puj4b`,
	"pT30": `ScheduledVisitItem-module__p-t-30___LrP0f`,
	"pT40": `ScheduledVisitItem-module__p-t-40___Da8nJ`,
	"pT50": `ScheduledVisitItem-module__p-t-50___lfccx`,
	"pL20": `ScheduledVisitItem-module__p-l-20___jfSZH`,
	"pL30": `ScheduledVisitItem-module__p-l-30___FQifZ`,
	"pL40": `ScheduledVisitItem-module__p-l-40___TgMc4`,
	"pR16": `ScheduledVisitItem-module__p-r-16___bmcgf`,
	"pR20": `ScheduledVisitItem-module__p-r-20___tTdyB`,
	"pR30": `ScheduledVisitItem-module__p-r-30___pX8Uu`,
	"pR50": `ScheduledVisitItem-module__p-r-50___AeHwU`,
	"pR60": `ScheduledVisitItem-module__p-r-60___o11h6`,
	"mB1": `ScheduledVisitItem-module__m-b-1___AR_WI`,
	"mB2": `ScheduledVisitItem-module__m-b-2___YLszg`,
	"mB6": `ScheduledVisitItem-module__m-b-6___tCUj5`,
	"mB8": `ScheduledVisitItem-module__m-b-8___k_NqQ`,
	"mB10": `ScheduledVisitItem-module__m-b-10___EkM1x`,
	"mB14": `ScheduledVisitItem-module__m-b-14___Ku3ow`,
	"mB16": `ScheduledVisitItem-module__m-b-16___TKFaF`,
	"mB20": `ScheduledVisitItem-module__m-b-20___NgiII`,
	"mB22": `ScheduledVisitItem-module__m-b-22___k9djL`,
	"mB24": `ScheduledVisitItem-module__m-b-24___n5Gkf`,
	"mB30": `ScheduledVisitItem-module__m-b-30___hBL_D`,
	"mB32": `ScheduledVisitItem-module__m-b-32____EZkS`,
	"mB40": `ScheduledVisitItem-module__m-b-40___FWulo`,
	"mT2": `ScheduledVisitItem-module__m-t-2___H4Drw`,
	"mT3": `ScheduledVisitItem-module__m-t-3___C5NKg`,
	"mT4": `ScheduledVisitItem-module__m-t-4___q6rt6`,
	"mT5": `ScheduledVisitItem-module__m-t-5___ES96z`,
	"mT8": `ScheduledVisitItem-module__m-t-8___DdAdB`,
	"mT10": `ScheduledVisitItem-module__m-t-10___vQ85N`,
	"mT15": `ScheduledVisitItem-module__m-t-15___KQlET`,
	"mT16": `ScheduledVisitItem-module__m-t-16___BVwZY`,
	"mT20": `ScheduledVisitItem-module__m-t-20___ro3TJ`,
	"mT22": `ScheduledVisitItem-module__m-t-22___rgLNt`,
	"mT30": `ScheduledVisitItem-module__m-t-30___bMXct`,
	"mT32": `ScheduledVisitItem-module__m-t-32___sR1E7`,
	"mLAuto": `ScheduledVisitItem-module__m-l-auto___DaaOT`,
	"mL4": `ScheduledVisitItem-module__m-l-4___Ka1MC`,
	"mL5": `ScheduledVisitItem-module__m-l-5____XA_w`,
	"mL6": `ScheduledVisitItem-module__m-l-6___MIG5x`,
	"mL8": `ScheduledVisitItem-module__m-l-8___Yq1Cn`,
	"mL10": `ScheduledVisitItem-module__m-l-10___QwMWW`,
	"mL16": `ScheduledVisitItem-module__m-l-16___BGByq`,
	"mL20": `ScheduledVisitItem-module__m-l-20___nXcJ2`,
	"mL24": `ScheduledVisitItem-module__m-l-24___A2QCw`,
	"mL30": `ScheduledVisitItem-module__m-l-30___nvV0R`,
	"mL35": `ScheduledVisitItem-module__m-l-35___ueZ8H`,
	"mL40": `ScheduledVisitItem-module__m-l-40___j4DQz`,
	"mR8": `ScheduledVisitItem-module__m-r-8___tFKeD`,
	"mR10": `ScheduledVisitItem-module__m-r-10___kgxqs`,
	"mR16": `ScheduledVisitItem-module__m-r-16___RiOdE`,
	"mR20": `ScheduledVisitItem-module__m-r-20___LyA1l`,
	"mR24": `ScheduledVisitItem-module__m-r-24___HLdF7`,
	"mR30": `ScheduledVisitItem-module__m-r-30___JSKIr`,
	"mR40": `ScheduledVisitItem-module__m-r-40___GZdA6`,
	"borderR3": `ScheduledVisitItem-module__border-r-3___NXACp`,
	"borderR4": `ScheduledVisitItem-module__border-r-4___kRmxm`,
	"borderR6": `ScheduledVisitItem-module__border-r-6___E_7wk`,
	"borderR10": `ScheduledVisitItem-module__border-r-10___VZDIq`,
	"borderR12": `ScheduledVisitItem-module__border-r-12___VJ7A4`,
	"borderR16": `ScheduledVisitItem-module__border-r-16___nHdQw`,
	"borderR50": `ScheduledVisitItem-module__border-r-50___KwZ7V`,
	"primaryBorder": `ScheduledVisitItem-module__primary-border___eYcEK`,
	"primaryBorderB": `ScheduledVisitItem-module__primary-border-b___LsVTV`,
	"primaryBorderT": `ScheduledVisitItem-module__primary-border-t___vzyJP`,
	"primaryBorderL": `ScheduledVisitItem-module__primary-border-l___Kl4sL`,
	"primaryBorderR": `ScheduledVisitItem-module__primary-border-r___oQ5at`,
	"secondaryBorder": `ScheduledVisitItem-module__secondary-border___xVcLN`,
	"secondaryBorderB": `ScheduledVisitItem-module__secondary-border-b___gaJLD`,
	"secondaryBorderT": `ScheduledVisitItem-module__secondary-border-t___Y6TOI`,
	"secondaryBorderL": `ScheduledVisitItem-module__secondary-border-l___RW1ov`,
	"secondaryBorderR": `ScheduledVisitItem-module__secondary-border-r___Su0oG`,
	"gap0": `ScheduledVisitItem-module__gap-0___c7IWU`,
	"gap2": `ScheduledVisitItem-module__gap-2___D1T6A`,
	"gap4": `ScheduledVisitItem-module__gap-4___cXZYT`,
	"gap5": `ScheduledVisitItem-module__gap-5___Wo6KK`,
	"gap6": `ScheduledVisitItem-module__gap-6___rW4Uv`,
	"gap8": `ScheduledVisitItem-module__gap-8___P2JB2`,
	"gap10": `ScheduledVisitItem-module__gap-10___MjKhe`,
	"gap12": `ScheduledVisitItem-module__gap-12___GjGvd`,
	"gap14": `ScheduledVisitItem-module__gap-14___sqFwC`,
	"gap16": `ScheduledVisitItem-module__gap-16___X1zh1`,
	"gap18": `ScheduledVisitItem-module__gap-18___q9P9a`,
	"gap20": `ScheduledVisitItem-module__gap-20___eFx95`,
	"gap24": `ScheduledVisitItem-module__gap-24___HNaQv`,
	"gap26": `ScheduledVisitItem-module__gap-26___m_1V5`,
	"gap30": `ScheduledVisitItem-module__gap-30___YG_Tq`,
	"gap32": `ScheduledVisitItem-module__gap-32___RUBGV`,
	"gap40": `ScheduledVisitItem-module__gap-40___Cx74p`,
	"gap50": `ScheduledVisitItem-module__gap-50___EBqTL`,
	"flex1": `ScheduledVisitItem-module__flex-1___rE3Wk`,
	"flexNone": `ScheduledVisitItem-module__flex-none___ri2gv`,
	"flexColumn": `ScheduledVisitItem-module__flex-column___IviW_`,
	"flexRow": `ScheduledVisitItem-module__flex-row___ipytB`,
	"verticallyCentered": `ScheduledVisitItem-module__vertically-centered___iD22A`,
	"horizontallyCentered": `ScheduledVisitItem-module__horizontally-centered___xIsjX`,
	"horizontallyEnd": `ScheduledVisitItem-module__horizontally-end___tduRK`,
	"verticallyStart": `ScheduledVisitItem-module__vertically-start___QOt5p`,
	"spaceBetween": `ScheduledVisitItem-module__space-between___BGwJt`,
	"flexWrap": `ScheduledVisitItem-module__flex-wrap___ObCid`,
	"height100": `ScheduledVisitItem-module__height-100___MbTtp`,
	"width50": `ScheduledVisitItem-module__width-50___QAb4a`,
	"width100": `ScheduledVisitItem-module__width-100___yuY3z`,
	"cursorPointer": `ScheduledVisitItem-module__cursor-pointer___Pl0DM`,
	"cursorNotAllowed": `ScheduledVisitItem-module__cursor-not-allowed___h7bu8`,
	"absoluteCentered": `ScheduledVisitItem-module__absolute-centered___yWKxL`,
	"absolute": `ScheduledVisitItem-module__absolute___KZPRE`,
	"relative": `ScheduledVisitItem-module__relative___s4cOP`,
	"fixed": `ScheduledVisitItem-module__fixed___QjJQR`,
	"visible": `ScheduledVisitItem-module__visible___jLlUZ`,
	"invisible": `ScheduledVisitItem-module__invisible___SnwZ0`,
	"col90": `ScheduledVisitItem-module__col-90___Dam91`,
	"colAuto": `ScheduledVisitItem-module__col-auto___FLkT4`,
	"medicalTabs": `ScheduledVisitItem-module__medical-tabs___VFtDd`,
	"medicalTableNew": `ScheduledVisitItem-module__medical-table-new___QsF7r`,
	"noPagination": `ScheduledVisitItem-module__no-pagination___qbMNv`,
	"medicalTableEmpty": `ScheduledVisitItem-module__medical-table-empty___X6I9f`,
	"iconBtn": `ScheduledVisitItem-module__icon-btn___TGQNH`,
	"searchIcon": `ScheduledVisitItem-module__search-icon___IdNRs`,
	"disableSelect": `ScheduledVisitItem-module__disable-select___cqNIY`,
	"breakWord": `ScheduledVisitItem-module__break-word___aryMq`,
	"popupClearBtn": `ScheduledVisitItem-module__popup-clear-btn___Qw4xt`,
	"scrollMB20": `ScheduledVisitItem-module__scroll-m-b-20___Bf6gh`,
	"container": `ScheduledVisitItem-module__container___E_TcF`,
	"checked": `ScheduledVisitItem-module__checked___L5DTl`,
	"disabled": `ScheduledVisitItem-module__disabled___jCWXQ`,
	"icon": `ScheduledVisitItem-module__icon___CYfep`,
	"title": `ScheduledVisitItem-module__title___bIOW6`,
	"type": `ScheduledVisitItem-module__type___O85l3`,
	"time": `ScheduledVisitItem-module__time___dbOVd`,
	"checkbox": `ScheduledVisitItem-module__checkbox___JY686`
};
module.exports = ___CSS_LOADER_EXPORT___;
